<template>
  <div class="writes-nav">
    <b-navbar toggleable="lg" variant="writes">
      <b-navbar-brand href="/">
        <img :src="require('@/assets/img/nav/logo.png')" alt="">
      </b-navbar-brand>

      <!-- 漢堡按鈕（自己控制） -->
      <b-navbar-toggle target="sidebar" />

      <!-- 桌機版選單 -->
      <b-collapse is-nav>
        <b-navbar-nav class="nav-gap align-items-center ml-auto">
          <b-nav-item @click="toMainDashboard">保存手寫字</b-nav-item>
          <b-nav-item href="https://www.pinkoi.com/store/writes" target="_blank">手寫字商店</b-nav-item>
          <b-nav-item-dropdown right v-if="isLoggedIn">
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <div class="avatar size-24px" v-if="user.MemberProfilePic">
                <img :src="user.MemberProfilePic" alt="avatar">
              </div>
              <Icon name="Initial_avatar" width="24" v-else></Icon>
              <Icon name="chevron-down" width="24"></Icon>
            </template>
            <b-dropdown-item @click="toMember">會員中心</b-dropdown-item>
            <b-dropdown-item href="#">說明中心</b-dropdown-item>
            <b-dropdown-item @click="logoutClicked">登出</b-dropdown-item>
          </b-nav-item-dropdown>

          <li class="nav-item" v-else>
            <router-link :to="{name:'Login'}" class="nav-link">
              <b-button variant="writes" size="lg">登入</b-button>
            </router-link>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- 右側滑出 Sidebar -->
    <b-sidebar
        id="sidebar"
        right
        shadow
        backdrop
    >
      <b-nav class="option-list fs-16px fw-semi-bold" vertical>
        <div class="d-flex flex-column">
          <b-nav-item @click="toMainDashboard">保存手寫字</b-nav-item>
          <b-nav-item>手寫字商店</b-nav-item>
          <template v-if="isLoggedIn">
            <b-nav-item @click="toMember">會員中心</b-nav-item>
            <b-nav-item>說明中心</b-nav-item>
          </template>
          <template v-else>
            <b-nav-item @click="toLogin">登入</b-nav-item>
          </template>
        </div>
        <div class="d-flex flex-column" v-if="isLoggedIn">
          <b-nav-item class="color-warning" @click="logoutClicked">登出</b-nav-item>
        </div>
      </b-nav>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { isNavigationFailure } from 'vue-router';

export default {
  name: 'TopNav',
  data() {
    return {
    };
  },
  props: {

  },
  components: {
  },
  computed: {
    ...mapGetters(['isStoreBusy', 'isMobileSize']),
    ...mapGetters('auth', ['hasToken']),
    ...mapState(['hideNav']),
    ...mapState('auth', ['user']),
    isLoggedIn() {
      return this.hasToken;
    },
  },
  watch: {
    $route() {
      // for (let i=0;i<this.links.length;i++) {
      //   this.links[i].show = false;
      //   this.showMenu = false;
      // }
    },
  },
  methods: {
    logoutClicked() {
      this.$store.dispatch('auth/logout');
      // this.$router.push({name: 'Login'});
      this.$router.push({name: 'Home'}).catch(err => {
        if (!isNavigationFailure(err)) {
          console.error(err) // 只有非導航失敗的錯誤才會顯示
        }
      });
    },
    toLogin() {
      if (this.$route.name === 'Login') return
      this.$router.push({ name: 'Login' });
    },
    toMember() {
      if (this.$route.name === 'MemberCenter') return
      this.$router.push({ name: 'MemberCenter' });
    },
    toMainDashboard() {
      if (this.$route.name === 'MainDashboard') return
      this.$router.push({ name: 'MainDashboard' });
    },
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
.writes-nav {
  nav.navbar-light.bg-writes {
    padding: 1.5rem 3rem;
    height: 96px;
    position: relative;
    color: $color-primary;
    background: $color-white;
    @include smaller-than-large {
      padding: .75rem 1.5rem;
    }
    .navbar-brand {
      padding: 0;
      >img {
        // width: 12rem;
        height: 100%;
        max-height: 46px;
      }
    }

    .nav-gap {
      gap: 2rem;
    }

    .nav-item .nav-link {
      padding: 0;
    }

    .btn.btn-writes {
      min-width: 112px;
      background-color: $color-primary;
      color: #fff;
    }

    .btn.btn-outline-writes {
      border-color: $color-main-green;
      color: $color-main-green;
    }
  }
  .option-list {
    justify-content: space-between;
    height: 100%;
    .nav-item {
      border-bottom: .5px solid $color-border;
    }
    a.nav-link {
      color: $color-primary;
      padding: 1rem 1.25rem;
    }
    .color-warning {
      a.nav-link {
        color: $color-warning;
      }
    }
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/main.scss";
.writes-nav {
  nav.navbar-light.bg-writes {
    .navbar-nav .nav-link {
      color: $color-primary;
    }
  }
  .dropdown-toggle.nav-link {
    display: flex;
    align-items: center;
    gap: .375rem;
    &::after {
      display: none;
    }
  }
}
.b-sidebar-backdrop.bg-dark {
  background: #000000!important;
}
</style>
